import { render, staticRenderFns } from "./LoginBox.vue?vue&type=template&id=6f455ff8&scoped=true&"
import script from "./LoginBox.vue?vue&type=script&lang=ts&"
export * from "./LoginBox.vue?vue&type=script&lang=ts&"
import style0 from "./LoginBox.vue?vue&type=style&index=0&id=6f455ff8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f455ff8",
  null
  
)

/* custom blocks */
import block0 from "./LoginBox.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports